import PropTypes from "prop-types";
import { Chip } from "@material-ui/core";

const STATUS_CONFIG = {
  open: { label: "Open", bgColor: "#EFF6FF", color: "#0369A1" },
  acknowledged: { label: "Acknowledged", bgColor: "#FFF3E0", color: "#E65100" },
  in_progress: { label: "In Progress", bgColor: "#FFFBEB", color: "#D97706" },
  waiting_on_customer: { label: "Waiting", bgColor: "#F5F3FF", color: "#7C3AED" },
  resolved: { label: "Resolved", bgColor: "#F0FDF4", color: "#16A34A" },
  closed: { label: "Closed", bgColor: "#F1F5F9", color: "#64748B" },
  reopened: { label: "Reopened", bgColor: "#FEF2F2", color: "#DC2626" },
};

const TicketStatusChip = ({ status, size = "small" }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.open;
  return (
    <Chip
      label={config.label}
      size={size}
      sx={{
        backgroundColor: config.bgColor,
        color: config.color,
        fontWeight: 500,
        fontSize: 12,
        borderRadius: "16px",
        px: 1.5,
        py: 0.25,
      }}
    />
  );
};

TicketStatusChip.propTypes = {
  status: PropTypes.string.isRequired,
  size: PropTypes.string,
};

export default TicketStatusChip;
